var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_vm._v(" "+_vm._s(_vm.mensagemDireitosReservados)+" "),_c('br'),_c('br'),_c('a',{on:{"click":function($event){return _vm.openTermLGPD()}}},[_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('b',[_c('u',[_vm._v("Acessar Política de Privacidade")])])
}]

export { render, staticRenderFns }